import { IFavoriteProfessional, IFavoriteProfessionalApi } from './favoriteProfessionalsTypes';

function toFavoriteProfessional(businessApi: IFavoriteProfessionalApi): IFavoriteProfessional {
  return {
    id: businessApi.id,
    fullName: businessApi.fullname,
    activityLevel: businessApi.activityLevel,
    averageProfessionalRating: businessApi.averageProfessionalRating,
    isAvailable: businessApi.isAvailable,
    hasMarkedAvailable: businessApi.hasMarkedAvailable,
    professions: businessApi.professions,
    profileImage: businessApi.profileImage,
    yearsOfExperience: businessApi.yearsOfExperience,
    badges: businessApi.badges ?? [],
    education: businessApi.education ?? {},
  };
}

export const favoriteProfessionalsAdapter = { toFavoriteProfessional };
